import React from 'react'
import VisibilitySensor from 'react-visibility-sensor'
import {
  ContinuationFetch,
  IContinuationState,
} from '../../types/continuationScroll'
import { useContinuation } from './hooks'
import Button from '../StyledButton'

export interface IContinuationScroll {
  render: React.SFC<IContinuationState>
  getItems?: ContinuationFetch
}

export const ContinuationScroll = ({
  render: Children,
  getItems,
}: IContinuationScroll) => {
  const [
    { items, totalCount, continuationToken, isLoading },
    getNextChunk,
  ] = useContinuation(getItems)

  return (
    <>
      <Children
        items={items}
        totalCount={totalCount}
        isLoading={isLoading}
        continuationToken={continuationToken}
      />
      {continuationToken && !isLoading ? (
        <VisibilitySensor
          onChange={(isVisible) => {
            if (isVisible) {
              getNextChunk(items, continuationToken)
            }
          }}
        >
          <Button
            onClick={() => {
              getNextChunk(items, continuationToken)
            }}
          >
            Show more
          </Button>
        </VisibilitySensor>
      ) : null}
    </>
  )
}
